import React from 'react';
import { Input, Typography } from '@material-tailwind/react';
import MsgInputError from './MsgInputError';

const InputGlobal = ({
  type,
  label,
  placeholder,
  errors,
  register,
  validations,
  formCamp,
  required,
  disabled = false,
  css = '',
  autoComplete = 'off',
}) => {
  const errorTexts = {
    required: 'Este campo é obrigatório',
  };

  return (
    <div className={`w-full flex-1 ${css}`}>
      <Typography
        variant="small"
        className="mb-1 text-left font-medium text-black dark:text-white capitalize"
      >
        {label} {required && '*'}
      </Typography>
      <Input
        type={type}
        size="lg"
        variant="outlined"
        placeholder={placeholder}
        className={`${
          !!errors
            ? `focus:!border-t-red-500  !border-red-500`
            : ' placeholder:text-gray-500  text-gray-900 !border !border-gray-300  placeholder:opacity-100 focus:!border-blue-900 focus:!border-t-blue-900 focus:ring-gray-900/10 '
        } placeholder:opacity-100   bg-white dark:bg-darkBgInput uppercase`}
        labelProps={{
          className: 'before:content-none after:content-none',
        }}
        containerProps={{
          className: 'min-w-full',
        }}
        error={!!errors}
        {...register(formCamp, validations)}
        autoComplete={autoComplete}
        disabled={disabled}
      />
      {errors && <MsgInputError text={errors[formCamp]?.message || errorTexts.required} />}
    </div>
  );
};

export default InputGlobal;
